import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-custom-object-multi-select-column",
    templateUrl: "./custom-object-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => CustomObjectMultiSelectColumnComponent), multi: true}
    ]
})
export class CustomObjectMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {

    EntityData = EntityData;

    @Input() productLineContext: boolean;
    @Input() inventoryContext: boolean;
    @Input() outletContext: boolean;
    @Input() membershipTypeContext: boolean;
    @Input() customObjectTypeId: number;
    @Input() excludeCustomObjectTypeId: number;

    constructor(injector: Injector) {
        super(injector, "id", "name");
    }
}
